import { CollectionItem, dataAssetIds, loadData } from "@prmf/site-data";
import { LoaderFunction } from "@remix-run/node";
import { ShouldRevalidateFunctionArgs } from "@remix-run/react";
export { KitchenParts as default } from "@prmf/site-screens";

export const loader: LoaderFunction = async ({ params }) => {
  const slug = params.slug!;
  if (!dataAssetIds.includes(slug)) {
    throw new Response(null, { status: 404, statusText: "Not Found" });
  }
  let items = await loadData(slug);
  if (slug === "handles") {
    // remove wardrobe handles
    items = (items as CollectionItem[]).filter((d) => !d.name.startsWith("70"));
  }
  return { items };
};

export function shouldRevalidate({
  defaultShouldRevalidate,
  formAction,
}: ShouldRevalidateFunctionArgs) {
  if (formAction === "/account/moodboard") return false;
  return defaultShouldRevalidate;
}
